import { useFormContext } from 'react-hook-form'

import { FormError, SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface InvestmentBucketIdFormFieldProps {
  investmentBuckets?: { label: string; value: number }[]
  loading?: boolean
}

export const InvestmentBucketIdFormField: React.FC<InvestmentBucketIdFormFieldProps> = ({
  investmentBuckets,
  loading,
}) => {
  const { control, setValue } = useFormContext<{ investment_bucket_id: number | null }>()

  return (
    <FormField
      name="investment_bucket_id"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Investment Bucket</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              placeholder={'Select an Investment Bucket'}
              value={field.value?.toString()}
              loading={loading}
              setValue={(val) =>
                setValue('investment_bucket_id', val ? parseInt(val) : null, {
                  shouldValidate: true,
                })
              }
              options={investmentBuckets?.map(({ label, value }) => ({
                label,
                value: value?.toString(),
              }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
